import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media } from '@clds/style-utils';
import ImageFit from '@cld/image-fit';
import { theme as t } from '../CustomTransformationCard/CustomTransformationCardTheme';

const phone = media.phone();

export const StyledAnchor = styled.a<{ isLoading?: boolean }>`
  max-width: 100%;
  width: 100%;

  ${({ isLoading }) =>
    isLoading &&
    css`
      visibility: hidden;
      z-index: 0;
    `};
`;

export const ImageWrapper = styled.figure<{ isSkeleton?: boolean }>`
  display: flex;
  flex-shrink: 0;
  width: ${t.imageWrapper.width};
  height: ${t.imageWrapper.height};
  margin: 0;
  border-radius: ${t.image.radius} 0 0 ${t.image.radius};
  overflow: hidden;
  align-self: stretch;
  position: relative;

  ${({ isSkeleton }) =>
    isSkeleton &&
    css`
      border-radius: ${t.image.radius} 0 0 ${t.image.radius};
      background: ${globalTheme.palette.surfaceAlt};
    `};

  @media ${phone} {
    border-bottom-left-radius: 0;
    height: ${t.imageWrapper.onPhone.height};
    width: 100%;
    align-items: center;
    justify-items: center;
    justify-content: center;
  }
`;

export const StyledImageFit = styled(ImageFit)<{ showCheckerboard: boolean }>`
  height: 100%;
  padding: ${globalTheme.spacing.xs};

  ${({ showCheckerboard }) =>
    !showCheckerboard &&
    css`
      /** 
    Unfortunately it has to be !important to overwrite the styles 
    from @cld/with-checkerboard-background - otherwise it causes a visual bug in mobile view 
    **/
      background: none !important;
    `};
`;
